<nz-layout class="height-full">
    <nz-content class="am-dash-main-content">
        <div class="main-container">
            <div class="grid-container">
                <div class="royalties-container">
                    <nz-alert
                        nzType="warning"
                        [nzMessage]="'Reporting period: ' + reportDateFrom + ' – ' + reportDateTo"
                        nzDescription="Data from the previous month may change until the 5th day of the current month."
                        nzShowIcon>
                    </nz-alert>
                    <button
                        nz-button
                        nzType="primary"
                        (click)="downloadRoyaltiesReport()"
                        [nzLoading]="isExporting"
                        nzSize="large">
                        <span nz-icon nzType="download" *ngIf="!isExporting"></span>
                        Generate last month report
                    </button>
                </div>
            </div>
        </div>
    </nz-content>
</nz-layout>
